import React from 'react';
import SettingsCard from '../../organisms/SettingsCard';
import Button from '../../atoms/Button';
import { BodyText, LabelText, Heading2 } from '../../atoms/Typography';
import StatusBadge from '../../atoms/StatusBadge';
import { useSettingsWizard } from '../../../context/SettingsWizardContext';
import { DEMO_CATEGORY_TYPES } from '../../../data/settingsSteps';
import Stepper from '../../organisms/Stepper';
import { SETTINGS_STEPS } from '../../../data/settingsSteps';
import Review from './Review';

export default function ReviewPublishStep({ onPublish, stepMeta, stepperProps }) {
  const { state } = useSettingsWizard();
  const categoryLabel =
    DEMO_CATEGORY_TYPES.find((c) => c.value === state.categoryType)?.label ||
    state.categoryType;

  return (
    <>
      <Stepper {...stepperProps} steps={SETTINGS_STEPS} />
      <SettingsCard
      title={stepMeta.title}
      description={stepMeta.description}
      showNext={false}
    >
      <div className="ca-review">
       
      
        <section className="ca-review__block ca-review__block--last">
          <Heading2>Form Fields</Heading2>
          {/* <BodyText>
            {state.formFields.length
              ? state.formFields.map((f) => f.name).join(', ')
              : 'No form fields added'}
          </BodyText> */}
          <Review />
        </section>

        <div className="ca-workflow__actions">
          <Button onClick={onPublish}>Publish</Button>
        </div>
      </div>
      </SettingsCard>
    </>
  );
}
